import * as React from 'react';

import { Input } from '../Form';
import { useIntl } from '../../providers';

interface BillingAddressProps {
    errors?: any;
    register: (options: object) => any;
}

const BillingAddress: React.FC<BillingAddressProps> = ({ errors, register }: BillingAddressProps) => {
    const { translate } = useIntl();

    return (
        <>
            <Input
                name="billingCompany"
                label={translate('orderForm.field.company', 'Company')}
                register={register}
                required
                error={errors?.billingCompany}
            />
            <Input
                name="billingStreet"
                label={translate('orderForm.field.street', 'Street')}
                register={register}
                required={true}
                error={errors?.billingStreet}
            />
            <Input
                name="billingCity"
                label={translate('orderForm.field.city', 'Zipcode / City')}
                register={register}
                required={true}
                error={errors?.billingCity}
            />
            <Input
                name="billingCountry"
                label={translate('orderForm.field.country', 'Country')}
                register={register}
                required={true}
                error={errors?.billingCountry}
            />
        </>
    );
};

export default React.memo(BillingAddress);
